import { FsDataService } from '@fairandsmart/angular';
import {
  DataFilter, DataFormat, DataFormatHelper, EntityCollection, EntityName, FsData,
} from '@fairandsmart/types';
import { Observable } from 'rxjs';
import { OrgaService } from '@Services/orga.service';
import { FlexIndexableEntity, FlexIndexDocument, FlexSearchService } from '../flex-search.service';
import { FlexEntityIndexer } from './flex-entity-indexer';

export abstract class DataIndexer extends FlexEntityIndexer<FsData, DataFilter> {
  protected constructor(
    protected readonly format: string,
    flexSearch: FlexSearchService,
    protected fsDataService: FsDataService,
    protected orgaService: OrgaService,
    batchNumber?: number,
  ) {
    super(`${EntityName.DATA}-${format}`, flexSearch, batchNumber);
  }

  isHandling(entity: FlexIndexableEntity): boolean {
    return entity.entityName === EntityName.DATA && DataFormatHelper.isExtending(entity.format, DataFormat.SHARED_PDS);
  }

  public abstract handle(entity: FsData): Observable<FlexIndexDocument>;

  protected search(filter: DataFilter): Observable<EntityCollection<FsData>> {
    return this.fsDataService.search(filter);
  }

  protected abstract getFilter(since: number, offset: number): DataFilter;
}
